import { render, staticRenderFns } from "./Bookkeep.vue?vue&type=template&id=1abfb4fb&scoped=true"
import script from "./Bookkeep.vue?vue&type=script&lang=js"
export * from "./Bookkeep.vue?vue&type=script&lang=js"
import style0 from "./Bookkeep.vue?vue&type=style&index=0&id=1abfb4fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abfb4fb",
  null
  
)

export default component.exports